<!--@TODO Artem replace isMobile checkings with global styles or use the same styles for all cases -->
@if (!isCollapsed) {
  <mat-form-field class="year-chooser compact no-error hover-background-primary">
    <mat-select [value]="user.financialYear" (selectionChange)="switch($event.value)" name="year-chooser-select">
      @for (year of user.financialYears; track year; let i = $index) {
        <mat-option [value]="year">
          @if (year == lastFinYear) {
            Current FY
          } @else {
            FY: {{ year | financialYear: 'long' }}
          }
        </mat-option>
      }
    </mat-select>
    <i matPrefix class="icon icon-calendar {{isMobile ? 'ic-primary' : 'ic-white'}}"></i>
    <i matSuffix class="fa fa-chevron-down fs-default {{isMobile ? 'ic-primary' : 'ic-white'}}"></i>
  </mat-form-field>
}

@if (isCollapsed) {
  <div class="year-label fw-bold c-secondary text-center">
    {{ user.financialYear | financialYear: 'long' }}
  </div>
}
